import { render, staticRenderFns } from "./GuiaRemisionForm.vue?vue&type=template&id=10fab98d&"
import script from "./GuiaRemisionForm.vue?vue&type=script&lang=js&"
export * from "./GuiaRemisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports